import './SonarTag.scss';
import classNames from 'classnames';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Tag } from 'antd';
import { Else, If, Then, When } from 'react-if';
import React, { useCallback } from 'react';
import { useCurrentUser, usePeriscopeActions, useTagReference } from '@hooks';
export const SonarTagDisplay = ({ noClick, noBorder, showDescription, tagId }) => {
    const { description, hexColor, id, name } = useTagReference(tagId);
    const { openPeriscope } = usePeriscopeActions();
    const { isGuest } = useCurrentUser();
    const handleTagClick = useCallback((e) => {
        e.stopPropagation();
        openPeriscope({
            id,
            name,
            openedFromIndex: -1,
            type: SonarObjectType.SonarTag
        });
    }, [id, name, openPeriscope]);
    if (!id) {
        return null;
    }
    const className = classNames('sonar-tag', { 'no-border': noBorder });
    const colorBlock = React.createElement("span", { className: 'color-block', style: { backgroundColor: hexColor } });
    return (React.createElement("div", { className: className },
        React.createElement(If, { condition: noBorder },
            React.createElement(Then, null,
                colorBlock,
                name),
            React.createElement(Else, null,
                React.createElement(Tag, { icon: colorBlock, onClick: isGuest || noClick ? undefined : handleTagClick }, name))),
        React.createElement(When, { condition: showDescription },
            React.createElement("span", { className: 'tag-description' }, description))));
};
